import React, { useEffect, useState } from "react";
import styled from "styled-components";

const ImageContainer = styled.div`
    cursor: pointer;
    position: relative;
    overflow: hidden;
`;

const StaffingCardImg = styled.img`
    width: 100%;
    height: 140px;
    filter: ${props => props.isSelected ? 'none' : 'grayscale(100%)'};
    border: ${props => (props.isSelected ? `5px solid ${props.borderColor}` : 'none')};

    @media screen and (max-width: 768px) {
        max-width: 100%;
        height: 90px;
    }
    
`;

const CardTitle = styled.p`
    text-align: left;
    font-family: Sunflower;
    font-size: 14px;
    text-decoration: none;
    color: #fff;
    position: absolute;
    bottom: 18%;
    left: 0;
    width: 100%;
    padding-left: 10%;

`;

export function StaffingCard({ title, img, onClick, isSelected, borderColor, showTitle }){

    return(
        <ImageContainer id="staffing-card-img-container" onClick={onClick}>
            <StaffingCardImg src={img} alt={title} isSelected={isSelected} borderColor={borderColor}/>
            {isSelected && showTitle && <CardTitle>{title}</CardTitle>}
        </ImageContainer>
    )
}